import { observer } from "mobx-react-lite";
import React, { useEffect, useRef } from 'react';

import AppState from '../../js/AppState';

import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '../../js/AppState';

import Footer from '../shared/Footer/Footer';

import Texts from 'react-sdk/Texts';
import Button from '../shared/Button/Button';


import illu_landscape from './assets/header_landscape.png';
import illu_portrait from './assets/header_portrait.png';

import logo from './assets/logo.png';

import './ScreenHome.css';

const ScreenHome = () => {
  let isMusicPlaying = useRef(false)

  useEffect(() => {
    playMusic()

    return (() => {
    })

  }, [])

  useEffect(() => {
    console.log(AppState.orientation)

  }, [AppState.orientation])

  function playMusic() {

    //if (isMusicPlaying.current == false) {

      //console.log("playMusic", isMusicPlaying.current)

      //SoundPlayer.playSound("landing")

      //isMusicPlaying.current = true
    //}

  }

  function startGame() {
    AppState.startGame()
  }

  function deleteSave(e) {
    e.preventDefault()
    AppState.deleteSave()
  }

  function openReglesTirage(e){
    console.log("test");
    e.preventDefault();
    PopupsManager.open(POPUPS.REGLES_TIRAGE);
  };


  return (
    <div className={"ScreenHome " + AppState.orientation} onClick={() => playMusic()}>
      <div className="Page">
        <div className="IllustrationContainer">
          <img src={AppState.orientation === "portrait" ? illu_portrait : illu_landscape} />
        </div>

        <div className="ContentContainer" >
          <div className='LogoBlock'>
            <div className="Date">{Texts.get("homepage-date")}</div>
            <img className="Logo" src={logo} />
          </div>
          <div className='TextsBlock'>
            <div className="Descr1">{Texts.get("homepage-description-1")}</div>
            <div className="Descr2" dangerouslySetInnerHTML={{ __html: Texts.get("homepage-description-2") }}></div>
          </div>

          <div className="ButtonsBlock">
            <Button scale={ AppState.orientation === "portrait" ? 1.5 : 1 } external={false} disabled={!AppState.gameReady} onClick={startGame}>
              {!AppState.saveExists && Texts.get("button-new-game")}
              {AppState.saveExists && Texts.get("button-resume-game")}
            </Button>
            {AppState.saveExists && <a href="#" onClick={deleteSave}>{Texts.get("homepage-delete-savegame")}</a>}
            {/*<a href={ Texts.get("homepage-reglement-lien") } target="_blank" rel="noreferrer">{ Texts.get("homepage-reglement-text") }</a>*/}
            <a href="#"  onClick={openReglesTirage}>{ Texts.get("homepage-reglement-text") }</a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default observer(ScreenHome)
